<div class="pre-load anim-loading" *ngIf="loadingList && violations.length === 0">
  <div class="row">
    <div class="col-md-12 text-center">
      <p>Carregando infrações...</p>
      <img
        src="/assets/loading/connect-loading.gif"
        class="connect-loading" />
    </div>
  </div>
</div>
<div class="container-fluid main pb-3 anim-loading" *ngIf="!loadingList || violations.length > 0">
  <div class="filters-area anim-loading" *ngIf="viewFilters">
    <button
      class="btn-secondary btn-close-filters"
      (click)="openOrCloseFilters()">
      <i class="material-icons">close</i>
    </button>
    <div class="area">
      <app-filters
        [contract]="contract"
        (filters)="setFilters($event)">
      </app-filters>
    </div>
  </div>
  <div class="row no-gutters">
    <div
      [ngClass]="{ 'col-md-11 offset-md-1': closedPanel, 'col-md-9 offset-md-3': !closedPanel }">
      <button class="btn btn-icon btn-icon-light mr-4 arrow-btn"
        [ngClass]="{ 'disabled': currentViolationView === 0}"
        (click)="prevViolation()">
        <i class="material-icons">
          keyboard_arrow_left
        </i>
        Anterior
      </button>
      <button class="btn btn-icon btn-icon-light arrow-btn"
        [ngClass]="{ 'disabled': currentViolationView === (violations.length -1) || violations.length <= 1}"
        (click)="nextViolation()">
        Próximo
        <i class="material-icons">
          keyboard_arrow_right
        </i>
      </button>
    </div>
  </div>
  <div class="row no-gutters row-items">
    <button
      *ngIf="closedPanel"
      class="btn btn-open-panel"
      title="Abrir Painel"
      (click)="openPanel()">
      <i class="material-icons">arrow_forward_ios_new</i>
    </button>
    <button
      class="btn btn-icon btn-apply-filters"
      title="Aplicar Filtros"
      (click)="openOrCloseFilters()"
      [ngClass]="{ 'btn-primary': viewFilters }"
      *ngIf="closedPanel">
      <i class="material-icons">filter_alt</i>
    </button>
    <div
      class="pr-1"
      [ngClass]="{ 'closed-panel': closedPanel, 'col-md-3': !closedPanel }">
      <app-list-panel
        [connected]="connected"
        [violations]="violations"
        [violationData]="violationData"
        [loadingList]="loadingList"
        [contract]="contract"
        [lastData]="lastData"
        (selectedViolation)="lastData=$event"
        (pauseEvent)="paused=$event"
        (closedEvent)="closedPanel=$event">
      </app-list-panel>
    </div>
    <div
      class="pl-1"
      [ngClass]="{ 'col-md-9': !closedPanel, 'col-md-12': closedPanel }">
      <div class="card card-featured"
        [ngClass]="{ 'bg-loading': lastData === undefined }">
        <div class="card-body">
          <div class="row heigh-100">
            <div class="col-1 pt-3">
              <button
                (click)="downloadFiles()"
                [ngClass]="{ 'disabled': lastData === undefined || downloadFilesLoading }"
                class="btn btn-icon pt-0 mt-0"
                title="Download de mídias">
                <i
                  class="material-icons"
                  *ngIf="!downloadFilesLoading">system_update_alt</i>
                <div
                  class="spinner-border" role="status"
                  *ngIf="downloadFilesLoading">
                  <span class="visually-hidden"></span>
                </div>
              </button>
              <br />
              <button
                class="btn btn-icon"
                title="Travar/Destravar Registro"
                (click)="setFixedLastData()"
                [ngClass]="{ 'btn-primary': fixedLastData, 'disabled': lastData === undefined || downloadFilesLoading }">
                <i class="material-icons">push_pin</i>
              </button>
            </div>
            <div
              class="col-11 d-flex justify-content-center align-items-center">
              <div
                class="d-flex justify-content-between align-items-center"
                *ngIf="lastData; else noData">
                <button
                  class="btn btn-icon"
                  [ngClass]="{ 'disabled': currentFileView === 0 }"
                  (click)="previousFileView()">
                  <span class="material-icons">
                    arrow_back_ios
                  </span>
                </button>
                <div class="files anim-loading">
                  <div class="file"
                    *ngFor="let file of lastData?.files">
                    <img
                      class="hide"
                      *ngIf="file?.type !== 'video'"
                      [ngClass]="{ 'visible': lastData?.files[currentFileView] === file }"
                      [src]="file?.urlCurrent"
                      crossorigin="*"
                      width="100%" />
                    <video
                      class="hide"
                      *ngIf="file?.type === 'video'"
                      [ngClass]="{ 'visible': lastData?.files[currentFileView] === file }"
                      crossorigin="anonymous"
                      [src]="file?.urlCurrent"
                      type="video/mp4" controls autoplay loop
                      playsinline muted disablePictureInPicture
                      controlsList="nodownload noplaybackrate"
                      [poster]="lastData?.files[0]?.urlCurrent"
                      oncontextmenu="return false;">
                    </video>
                    <img
                      [ngClass]="{ 'hide': lastData?.files[currentFileView] !== file }"
                      class="invisible"
                      *ngIf="file?.type === 'video'"
                      [src]="lastData?.files[0]?.urlCurrent"
                      crossorigin="*"
                      width="100%" />
                  </div>
                </div>
                <button
                  class="btn btn-icon"
                  [ngClass]="{ 'disabled': lastData?.files.length === 1 || currentFileView === lastData?.files.length - 1 }"
                  (click)="nextFileView()">
                  <span class="material-icons">
                    arrow_forward_ios
                  </span>
                </button>
              </div>
            </div>
          </div>
          <ng-template #noData>
            <div class="text-center">
              <p><em>Aguardando recebimento de dados...</em></p>
            </div>
          </ng-template>
        </div>
      </div>
      <div class="row no-gutters mt-2">
        <div class="col-md-8 pr-1">
          <div
            class="card card-info bg-gray--200 border-left"
            [style]="{
              'border-color': getRegulationColor(lastData?.regulationId) + '!important',
              'border-left-color': getRegulationColor(lastData?.regulationId) + '!important'
              }">
            <div
              class="card-body text-detail">
              <div class="row justify-content-between mb-3">
                <div class="col-item">
                  <p class="bold">Enquadramento</p>
                  <div class="content" *ngIf="!loadingSpotLane">
                    <p
                      *ngIf="getRegulationByPassId(lastData?.passId) !== undefined"
                      class="regulation-code"
                      [title]="getRegulationByPassId(lastData?.passId)?.shortDescription || ''">
                      {{
                      getRegulationByPassId(lastData?.passId)?.code ||
                      lastData?.regulationId || '-'
                      }}
                    </p>
                    <p
                      *ngIf="getRegulationByPassId(lastData?.passId) === undefined">-</p>
                  </div>
                  <div class="loading-spinner" *ngIf="loadingSpotLane">
                    <div class="bounce1"></div>
                    <div class="bounce2"></div>
                    <div class="bounce3"></div>
                  </div>
                </div>
                <div class="col-item">
                  <p class="bold">Data</p>
                  <p>{{ lastData?.date | moment: 'DD/MM/YYYY'}}</p>
                  <p *ngIf="!lastData?.date">-</p>
                </div>
                <div class="col-item">
                  <p class="bold">Hora</p>
                  <p>{{ lastData?.date | moment: 'HH:mm:ss'}}</p>
                  <p *ngIf="!lastData?.date">-</p>
                </div>
                <div class="col-item">
                  <p class="bold">Vel. Permitida</p>
                  <p>{{lastData?.speedLimit || '-' }} Km/h</p>
                </div>
                <div class="col-item">
                  <p class="bold">Vel. Registrada</p>
                  <p>{{lastData?.speed || '-' }} Km/h</p>
                </div>
              </div>
              <div class="row justify-content-between mb-3">
                <div class="col-item">
                  <p class="bold">Faixa</p>
                  <p>{{ lastData?.laneCode || '-' }} Fx {{ lastData?.laneNumber
                    || '-' }}</p>
                </div>
                <div class="col-item">
                  <p class="bold">Local</p>
                  <p>{{ lastData?.address?.street || '-' }}</p>
                </div>
              </div>
              <div class="row justify-content-between">
                <div class="col-item">
                  <p class="bold">Série do Equipamento</p>
                  <p>{{ lastData?.equipment?.serialNumber || '-' }}</p>
                </div>
                <div class="col-item">
                  <p class="bold">Data da Aferição</p>
                  <p>{{ lastData?.equipment?.calibration?.date | moment:
                    'DD/MM/YYYY' }}</p>
                  <p *ngIf="!lastData?.equipment?.calibration?.date">-</p>
                </div>
                <div class="col-item">
                  <p class="bold">Identificação da Infração</p>
                  <p>{{ lastData?.passId || '-' }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 pl-1">
          <div class="card card-info bg-gray--200">
            <div class="card-body text-detail">
              <div class="row justify-content-between mb-3">
                <div class="col-item">
                  <p class="bold">Placa</p>
                  <p class="plate"
                    *ngIf="lastData?.vehicle?.plateOCR || lastData?.vehicle?.plate">
                    <strong>
                      {{ lastData?.vehicle?.plateOCR || lastData?.vehicle?.plate
                      }}
                    </strong>
                  </p>
                  <p
                    *ngIf="lastData?.vehicle?.plateOCR === '' || lastData?.vehicle?.plate === '' ">-</p>
                </div>
                <div class="col-item">
                  <p class="bold">Cor</p>
                  <p>{{ lastData?.vehicle?.color || '-' }}</p>
                </div>
                <div class="col-item">
                  <p class="bold">Ano</p>
                  <p>{{ lastData?.vehicle?.year || '-' }}</p>
                </div>
              </div>
              <div class="row justify-content-between mb-3">
                <div class="col-item">
                  <p class="bold">Tipo</p>
                  <p>{{ lastData?.vehicle?.type || '-' }}</p>
                </div>
                <div class="col-item">
                  <p class="bold">Marca/Modelo</p>
                  <p>{{ lastData?.vehicle?.brandModel || '-' }}</p>
                </div>
                <div class="col-item">
                  <p class="bold">Classificação</p>
                  <p>{{ lastData?.vehicle?.classificationCode || '-' }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
